import { darken, getLuminance, lighten } from 'polished';
import styled, { css } from 'styled-components';
import { getHoveredOrSelectedColour } from './colour-helpers';

export const SpecialButton = styled.button<{
	$background: string;
	$color: string;
	$borderRadius?: number | '';
	$fontFamily?: string;
	$fontSize?: string | number;
	$fontWeight?: number;
	$fontStyle?: string;
	$textDecoration?: string;
	$minWidth?: number;
	$borderSize?: number | '';
	$borderColor?: string;
	$hoverBackgroundColour?: string;
	$selected?: boolean;
	$selectedBackgroundColour?: string;
}>`
	border-radius: ${props => props.$borderRadius ?? '0'}px;
	border: 0;
	padding-inline: 10px;
	padding-block: 6px;
	cursor: pointer;
	font-family: ${props => props.$fontFamily ?? ''};
	font-size: ${props => props.$fontSize ?? ''};
	font-weight: ${props => props.$fontWeight ?? ''};
	font-style: ${props => props.$fontStyle ?? ''};
	text-decoration: ${props => props.$textDecoration ?? ''};
	${props => (props.$minWidth ? `min-width: ${props.$minWidth}px;` : '')}
	border-width: ${props => props.$borderSize ?? 0}px;
	border-color: ${props => props.$borderColor ?? ''};
	border-style: ${props => (props.$borderSize ? 'solid' : '')};

	${props => {
		let color = props.$color;
		const background = props.$selected
			? (props?.$selectedBackgroundColour ?? getHoveredOrSelectedColour(props.$background, 0.2))
			: props.$background;
		const luminanceDiff = Math.abs(getLuminance(background) - getLuminance(color));
		if (luminanceDiff < 0.4) {
			// console.log('Luminance difference is too small, adjusting color for better contrast', color, background);
			color = getLuminance(color) > 0.5 ? darken(0.8, color) : lighten(0.8, color);
		}

		return css`
			background: ${background};
			color: ${color};
			&:focus {
				outline: 1px solid ${darken(0.2, background)};
			}
		`;
	}}

	/* Hover effect */
	&:hover {
		${props => {
			let hoverBg = props.$hoverBackgroundColour ?? getHoveredOrSelectedColour(props.$background, 0.3);
			let color = props.$color;
			const luminanceDiff = Math.abs(getLuminance(hoverBg) - getLuminance(color));
			if (luminanceDiff < 0.4) {
				// console.log('Luminance difference is too small, adjusting color for better contrast', color, hoverBg);

				// special case for hover colour being exactly the same as the text colour
				// we just invert the background and text colour
				if (hoverBg === color) {
					color = props.$background;
				} else {
					color = getHoveredOrSelectedColour(color, 0.8);
				}
			}
			return css`
				background: ${hoverBg};
				color: ${color};
				&:focus {
					outline: 1px solid ${darken(0.2, color)};
				}
			`;
		}}
	}
`;

export const alignDictionary = {
	left: 'flex-start',
	center: 'center',
	right: 'flex-end'
};

export const justifyDictionary = {
	...alignDictionary,
	spaceEvenly: 'space-evenly',
	spaceAround: 'space-around',
	spaceBetween: 'space-between'
};
